module.exports = __webpack_public_path__ + "static/media/ru.7a8b3a7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ru.svg
// module id = 236
// module chunks = 0